var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "./Button", "../Icon/Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("./Button"), require("../Icon/Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.Button, global.Icon);
    global.ConcertButton = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _Button, _Icon) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _Button = _interopRequireDefault(_Button);
  _Icon = _interopRequireDefault(_Icon);
  var cdnUrl = "https://static-cdn.arte.tv/static/styleguide/4.0.4";

  var ConcertButton = function ConcertButton(_ref) {
    var iconImage = _ref.iconImage,
        label = _ref.label,
        onClick = _ref.onClick,
        role = _ref.role;
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "next-button--outline next-button--icon-right next-button--concert",
      label: label,
      icons: [/*#__PURE__*/_react.default.createElement("img", {
        src: iconImage,
        alt: "ARTE Concert"
      }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: "arte-next-calendar",
        size: "small"
      })],
      onClick: onClick,
      role: role
    });
  };

  ConcertButton.propTypes = {
    iconImage: _propTypes.default.string,
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired,
    role: _propTypes.default.string
  };
  ConcertButton.defaultProps = {
    iconImage: "".concat(cdnUrl, "/img/logos/arte-concert.svg"),
    label: 'À venir sur',
    onClick: function onClick() {
      return null;
    }
  };
  var _default = ConcertButton;
  _exports.default = _default;
});